// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LeftNav.css - Exact Figma Specs */

.left-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 220px;
  height: 100%;
  background-color: #FFFFFF;
  border-radius: 0 20px 20px 0;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}

.nav-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 24px;
  padding: 24px 0 0 0;
}

.nav-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.nav-logo img {
  width: 110px;
  height: 41px;
}

/* Nav Items Container */
.nav-items {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Individual Nav Item */
.nav-item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  width: 100%;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.2s ease;
}

.nav-item:hover:not(.nav-item-active):not(.nav-item-locked) {
  background-color: rgba(35, 108, 255, 0.08);
}

/* Active state - blue background */
.nav-item-active {
  background-color: #236CFF;
}

/* Side indicator bar for active item */
.nav-item-indicator {
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 40px;
  background-color: #FFFFFF;
}

/* Content container inside nav item */
.nav-item-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  flex: 1;
}

/* Icon */
.nav-item-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

/* Default state icons - gray */
.nav-item:not(.nav-item-active) .nav-item-icon {
  filter: brightness(0) saturate(100%) invert(62%) sepia(8%) saturate(518%) hue-rotate(169deg) brightness(90%) contrast(89%);
}

/* Active state icons - white */
.nav-item-active .nav-item-icon {
  filter: brightness(0) invert(1);
}

/* Label text */
.nav-item-label {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
}

/* Default state label - gray (from Figma) */
.nav-item:not(.nav-item-active) .nav-item-label {
  color: #859299;
}

/* Active state label - white */
.nav-item-active .nav-item-label {
  color: #FFFFFF;
}

/* Hover state for non-active items - darker */
.nav-item:not(.nav-item-active):not(.nav-item-locked):hover .nav-item-label {
  color: #103661;
}

/* Locked state - dimmed and non-interactive */
.nav-item-locked {
  cursor: not-allowed;
  opacity: 0.5;
}

.nav-item-locked:hover {
  background-color: transparent;
}

.nav-item-locked .nav-item-label {
  color: #C4CDD0;
}

.nav-item-locked .nav-item-icon {
  filter: brightness(0) saturate(100%) invert(85%) sepia(6%) saturate(200%) hue-rotate(169deg) brightness(95%) contrast(90%);
}
`, "",{"version":3,"sources":["webpack://./src/styles/LeftNav.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,OAAO;AACT;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,0HAA0H;AAC5H;;AAEA,+BAA+B;AAC/B;EACE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0HAA0H;AAC5H","sourcesContent":["/* LeftNav.css - Exact Figma Specs */\n\n.left-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 220px;\n  height: 100%;\n  background-color: #FFFFFF;\n  border-radius: 0 20px 20px 0;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);\n  flex-shrink: 0;\n}\n\n.nav-top {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  gap: 24px;\n  padding: 24px 0 0 0;\n}\n\n.nav-logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.nav-logo img {\n  width: 110px;\n  height: 41px;\n}\n\n/* Nav Items Container */\n.nav-items {\n  display: flex;\n  flex-direction: column;\n  align-self: stretch;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/* Individual Nav Item */\n.nav-item {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n  width: 100%;\n  height: 40px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  transition: background-color 0.2s ease;\n}\n\n.nav-item:hover:not(.nav-item-active):not(.nav-item-locked) {\n  background-color: rgba(35, 108, 255, 0.08);\n}\n\n/* Active state - blue background */\n.nav-item-active {\n  background-color: #236CFF;\n}\n\n/* Side indicator bar for active item */\n.nav-item-indicator {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 4px;\n  height: 40px;\n  background-color: #FFFFFF;\n}\n\n/* Content container inside nav item */\n.nav-item-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  flex: 1;\n}\n\n/* Icon */\n.nav-item-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n/* Default state icons - gray */\n.nav-item:not(.nav-item-active) .nav-item-icon {\n  filter: brightness(0) saturate(100%) invert(62%) sepia(8%) saturate(518%) hue-rotate(169deg) brightness(90%) contrast(89%);\n}\n\n/* Active state icons - white */\n.nav-item-active .nav-item-icon {\n  filter: brightness(0) invert(1);\n}\n\n/* Label text */\n.nav-item-label {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.43;\n  text-align: left;\n}\n\n/* Default state label - gray (from Figma) */\n.nav-item:not(.nav-item-active) .nav-item-label {\n  color: #859299;\n}\n\n/* Active state label - white */\n.nav-item-active .nav-item-label {\n  color: #FFFFFF;\n}\n\n/* Hover state for non-active items - darker */\n.nav-item:not(.nav-item-active):not(.nav-item-locked):hover .nav-item-label {\n  color: #103661;\n}\n\n/* Locked state - dimmed and non-interactive */\n.nav-item-locked {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.nav-item-locked:hover {\n  background-color: transparent;\n}\n\n.nav-item-locked .nav-item-label {\n  color: #C4CDD0;\n}\n\n.nav-item-locked .nav-item-icon {\n  filter: brightness(0) saturate(100%) invert(85%) sepia(6%) saturate(200%) hue-rotate(169deg) brightness(95%) contrast(90%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
